import React from 'react';
import './faq.css';
import {Helmet} from "react-helmet";

const Faq = () => {
    return (
        <div>
            <Helmet>
                <title> Faq </title>
                <meta
                    name="Faq"
                    content="This is faq page"
                />
            </Helmet>
            <div className="container faq" style={{position: 'relative'}}>
                <h2 className="title">Faq</h2>
                <h1 style={{textAlign: 'center', fontSize: '5vw', color: 'red'}}> Frequently Asked Questions </h1>
            </div>
        </div>
    );
};

export default Faq;